//Utility Packages
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

export const MatchProfileEvaluation = (props) => {
  const { onHide, show, matchEvaluationData } = props;
  const discription =
    matchEvaluationData && Object.keys(matchEvaluationData)?.find((item) => item === 'Description');

  return (
    <Dialog
      header="Profile Match Evaluation"
      visible={show}
      className="card overflow-hidden resize-none person-details-popup"
      onHide={onHide}>
      {matchEvaluationData &&
        Object.keys(matchEvaluationData).length !== 0 &&
        Object.keys(matchEvaluationData).map((key, index) => {
          if (key !== 'Description') {
            return (
              <div className="detail-row" key={index}>
                <p className="title">
                  <span>{key}</span>
                  <span className="colon">:</span>
                </p>
                <div className="content">
                  <span>{matchEvaluationData[key]}</span>
                </div>
              </div>
            );
          }
          return null;
        })}
      <Divider />
      {discription && (
        <div
          className="m-0"
          dangerouslySetInnerHTML={{
            __html: matchEvaluationData[discription] || ''
          }}
        />
      )}
    </Dialog>
  );
};
